var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('PsDataTable',{staticClass:"psui-w-full psui-mt-3",attrs:{"header":_vm.getTableHeaders,"data":_vm.getTableRows,"footer":_vm.getTableFooter,"type":'simple',"align":"right"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }